import { Button, Typography } from '@mui/material'
import { FC, useState } from 'react'
import { InformationModal } from 'utoniq-ui'

import { ArtistRemovePostCategoryInput } from '@/clients/utoniq-core/schema'
import { useMessage, useTranslation } from '@/core'
import { captureError } from '@/core/errors'

export type DeletePostCategoryModalProps = {
  open: boolean
  onClose: () => void
  onDeleteCategory: (inputs: ArtistRemovePostCategoryInput) => Promise<void>
  id: string
}

export const DeleteCategoryModal: FC<DeletePostCategoryModalProps> = ({
  open,
  onClose,
  onDeleteCategory,
  id,
}) => {
  const { t } = useTranslation('consolePostCategories')
  const { showMessage } = useMessage()
  const [loading, setLoading] = useState(false)

  const onDeletePostCategory = async () => {
    setLoading(true)
    return onDeleteCategory({ categoryId: id })
      .then(() => {
        showMessage(t('completeRemoveCategory'))
        onClose()
      })
      .catch(e => {
        captureError(e, 'consoleCategoryDelete')
      })
      .finally(() => {
        setLoading(false)
      })
  }
  return (
    <InformationModal
      open={open}
      onClose={onClose}
      title={t('deleteCategoryModalTitle')}
      innerSx={{
        width: 300,
      }}
      content={
        <>
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: 13,
              fontWeight: 300,
            }}
          >
            {t('removeCategoryDescription')}
          </Typography>

          <div style={{ marginTop: '32px' }}>
            <Button
              color="primary"
              size="large"
              fullWidth
              onClick={onDeletePostCategory}
              loading={loading}
              disabled={loading}
            >
              {t('removeCategory')}
            </Button>
          </div>
          <div style={{ marginTop: '16px' }}>
            <Button variant="text" onClick={onClose}>
              {t('cancel')}
            </Button>
          </div>
        </>
      }
    />
  )
}
